import React from 'react';
import { Alert, AlertIcon, Box } from '@chakra-ui/react';
import { usePublicFeatureFlags } from '../../hooks/usePlatformSettings';

const PlatformStatusBanner = () => {
	const { data } = usePublicFeatureFlags();

	if (!data?.maintenanceMode) return null;

	return (
		<Box px={4} pt={3}>
			<Alert status='warning' borderRadius='md'>
				<AlertIcon />
				{data.maintenanceMessage ||
					'OpsPilot CRM is temporarily unavailable for maintenance.'}
			</Alert>
		</Box>
	);
};

export default PlatformStatusBanner;
